__turbopack_context__.v({
  "donny-spotlight-pulse": "DonnyActionProvider-module__jOzSdG__donny-spotlight-pulse",
  "liveRegion": "DonnyActionProvider-module__jOzSdG__liveRegion",
  "spotlightFrame": "DonnyActionProvider-module__jOzSdG__spotlightFrame",
  "spotlightFrameStatic": "DonnyActionProvider-module__jOzSdG__spotlightFrameStatic",
  "spotlightLayer": "DonnyActionProvider-module__jOzSdG__spotlightLayer",
});
